package scenes.test

import assets.*
import com.github.quillraven.fleks.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.view.*
import com.soywiz.korge.view.Camera
import com.soywiz.korge.view.camera.*
import com.soywiz.korim.color.*
import com.soywiz.korma.geom.*
import component.*
import input.*
import org.jbox2d.dynamics.*
import org.jbox2d.dynamics.World
import system.*

class Bo2dSeparatedScene: Scene() {
    private val animations = mutableMapOf<String, SpriteAnimation>()

//    private val physicWorld = World(Vec2(0f, 10f)).apply {
//        customScale = 100.0
//    }

    private lateinit var physicWorld: World

    override suspend fun SContainer.sceneInit() {
        loadPlayerAnimation("characters/ninja_frog").forEach {
            animations["ninja-frog-${it.key.name}"] = it.value
        }

        physicWorld = getOrCreateBox2dWorld().world
    }

    override suspend fun SContainer.sceneMain() {
        println("MultiplayerRunScene sceneMain")

        val camera = Camera()
        val cameraContainer = cameraContainer(width, height, clip) {
            camera.addTo(this) {
//                WorldObjectFactory.createGround(physicWorld, this)

                val ground = solidRect(500.0, 10.0, Colors.WHITE)
                    .position(0,300)

                val groundBody = physicWorld.createBody(BodyDef().apply {
                    type = BodyType.STATIC
                    position.set(ground.x / physicWorld.customScale, ground.y / physicWorld.customScale)
                    active = true
                }).fixture {
                    shape = BoxShape(Rectangle(
                        x = ground.x,
                        y = ground.y,
                        width = ground.width,
                        height = ground.height
                    ) / physicWorld.customScale
                    ).apply {
                        println("""
                            ${this.vertices.joinToString { it.toString() }}
                        """.trimIndent())
                    }
                    restitution = 0.2f
                }

                ground.body = groundBody
                groundBody.view = ground

                println("""
                    ground: ${ground.x}, ${ground.y}
                    shape: ${ground.width}, ${ground.height} 
                    
                    groundBody: ${groundBody.position.x}, ${groundBody.position.y}
                    shape: ${groundBody}
                """.trimIndent())

                val leftWall = solidRect(10.0, 300.0, Colors.RED)
                    .position(0,0)

                val rightWall = solidRect(10.0, 150.0, Colors.GREEN)
                    .position(250,150)
            }
        }

        val keyboardControllerView = solidRect(1, 1, Colors.TRANSPARENT_BLACK)
        val keyboardController = KeyboardController(keyboardControllerView)
        keyboardControllerView.addComponent(keyboardController)

        val world = world {
            injectables {
                add(SCENE_CONTAINER, this@sceneMain)
                add(physicWorld)
                add(keyboardController)
                add(cameraContainer)
                add(camera)
            }

            components {
                onAdd(PhysicComponent, PhysicComponent.onAddPhysic)
                onRemove(PhysicComponent, PhysicComponent.onRemovePhysic)
            }

            systems {
//                add(PlayerSpawnSystem().apply { respawnPlayer = true })
                add(PlayerControlSystem())
                add(Box2dStepSystem())
                add(PlayerAnimationSystem())
                add(SpriteAnimationSystem(animations))
                add(PhysicDebugSystem())
            }
        }

//        addFixedUpdater(16.milliseconds) {
//            world.update(16f)
//        }
        addUpdater { dt ->
            world.update(dt.seconds.toFloat())
        }
    }
}
